import { makeStyles } from '@material-ui/core';
import { Card, Col, Row } from 'antd';

const useStyles = makeStyles(theme => ({
    statsCard: {
        fontSize: 18,
        color: 'red',
        marginBottom: '16px',
    },
    cardStyle: {
        borderRadius: '6px',
        boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)',
        fontSize: '25px',
        fontWeight: 'bold',
    },
    progress: {
        borderRadius: '6px',
        boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)',
        fontSize: '25px',
        fontWeight: 'bold',
        marginTop: '20px',
        background: '#fff',
        padding: '10px 15px 13px 20px',
    },
    heading: {
        fontWeight: 'normal',
        fontFamily: 'Poppins',
        fontSize: '16px',
        color: '#5a607f',
    }
}))

/**
 * Drawer to add a new job 
 */
const TasksStats = ({ task_stats }) => {

    const classes = useStyles()

    const claculateProgres = () => {
        let total = parseInt(task_stats.total)
        let completed = parseInt(task_stats.completed)
        let percent = parseInt((completed / total) * 100)
        return percent
    }

    return (
        <div className={classes.statsCard}>
            <Row gutter={16}>
                {/* <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Total Tasks </h3>
                        {task_stats.total}
                    </Card>
                </Col> */}
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> In Queue </h3>
                        {task_stats.message_in_queue}
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Processing </h3>
                        {task_stats.processing}
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Completed </h3>
                        {task_stats.done}
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Error Tasks </h3>
                        {task_stats.error}
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Retried </h3>
                        {task_stats.total_retried}
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} className={classes.cardStyle}>
                        <h3 className={classes.heading}> Scraped Item </h3>
                        {task_stats.scraped_item}
                    </Card>
                </Col>
            </Row>
            {/* <Row>
                <Col span={24}>
                    <div className={classes.progress}>
                        <Progress percent={claculateProgres()} />
                    </div>
                </Col>
            </Row> */}
        </div>
    )
}

export default TasksStats